import React, { Component } from 'react';
import { AutoSizer, Column, Table } from 'react-virtualized';
import 'react-virtualized/styles.css';

export class VirtualizedTable extends Component{
    constructor(props){
        super(props);

        let sortBy = props.sortBy ? props.sortBy : null;
        let sortDirection = props.sortDirection ? props.sortDirection : "ASC";
        let list = props.list ? props.list : [];
        let sortedList = this._sortList(sortBy, sortDirection, list);

        this.state = {
            styles: {
                headerClassName: "header",
                rowClassName: "row",
                noRows: "no-rows"
            },
            hideIndexRow: false,
            overscanRowCount: 10,
            disableHeader: false,
            headerHeight: props.headerHeight ? props.headerHeight : 50,
            rowHeight: props.rowHeight ? props.rowHeight : 50,
            rowCount: props.list ? props.list.length : 0,
            noRowsText: props.noRowsText ? props.noRowsText : "No results.",
            scrollToIndex: undefined,
            sortBy,
            sortDirection,
            sortedList,
            height: props.height ? props.height : 550,
            width: props.width ? props.width : 500,
            columns: props.columns ? props.columns : [],
            list: list, // Array of Objects
            headerRenderer: props.headerRenderer ? props.headerRenderer : this._headerRenderer,
            cellRenderer: props.cellRenderer ? props.cellRenderer : this._cellRenderer,
            disableHeight: props.disableHeight ? props.disableHeight : false
        };

        this.generateColumns = this.generateColumns.bind(this);
        this._noRowsRenderer = this._noRowsRenderer.bind(this);
        this._headerRenderer = this._headerRenderer.bind(this);
        this._cellRenderer = this._cellRenderer.bind(this);
        this._rowGetter = this._rowGetter.bind(this);
        this._sortList = this._sortList.bind(this);
        this._sort = this._sort.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        var currList = JSON.stringify(this.props.list);
        var nextList = JSON.stringify(nextProps.list);
        if (currList !== nextList) {
            let { sortBy, sortDirection } = this.state;
            let sortedList = this._sortList(sortBy, sortDirection, nextProps.list);
            this.setState({ 
                list: nextProps.list,
                sortedList: sortedList,
                rowCount: nextProps.list.length
            });
        }
    }

    _sort({ sortBy, sortDirection }) {
        let { list } = this.state ? this.state : this.props; // Initial render
        let sortedList = this._sortList(sortBy, sortDirection, list);
        this.setState({ sortBy, sortDirection, sortedList });
    }

    _sortList(sortBy, sortDirection, list) {
        if (sortDirection === "ASC")
            return list.sort((a, b) => { 
                if(a[sortBy] < b[sortBy]) return -1;
                if(a[sortBy] > b[sortBy]) return 1;
                return 0;
            });
        return list.sort((a, b) => { 
            if(a[sortBy] < b[sortBy]) return -1;
            if(a[sortBy] > b[sortBy]) return 1;
            return 0;
        }).reverse();
    }

    _rowGetter({ index }) {
        let { sortedList } = this.state;
        return sortedList  && sortedList[index % sortedList.length] 
             ? sortedList[index % sortedList.length] 
             : [];
    }

    _noRowsRenderer() {
        let { styles, noRowsText } = this.state;
        return <div className={styles.noRows}>{noRowsText}</div>;
    }

    _headerRenderer({
        dataKey,
        label,
        sortBy,
        sortDirection
      }) {
        const showSortIndicator = sortBy === dataKey;
        const arrowClassName = sortDirection === "ASC" ? "up-arrow" : "down-arrow";
        return (<div>
                    { label }
                    { showSortIndicator
                    ? <span className={"arrows " + arrowClassName}></span> 
                    : "" }
                </div>);
        
    }

    _cellRenderer({
        cellData
      }) {
        return <div>{ cellData }</div>;
    }

    generateColumns() {
        let { columns } = this.state;
        if (!columns) return null;
        let { headerRenderer, cellRenderer } = this.state;
        return columns.map(column => <Column
                                        key={column.dataKey}
                                        label={column.label}
                                        dataKey={column.dataKey}
                                        width={column.width}
                                        headerRenderer={headerRenderer}
                                        cellRenderer={cellRenderer} />);
    }

    render() {
        let { 
            headerHeight, 
            rowHeight,
            rowCount,
            sortBy,
            sortDirection,
            height,
            disableHeight } = this.state;
        return (
            <AutoSizer
                disableHeight={disableHeight}>
                {({ width }) => (
                    <Table
                        width={width}
                        height={height}
                        headerHeight={headerHeight}
                        rowHeight={rowHeight}
                        rowCount={rowCount}
                        rowGetter={this._rowGetter}
                        noRowsRenderer={this._noRowsRenderer}
                        sortBy={sortBy}
                        sortDirection={sortDirection}
                        sort={this._sort}>
                        { this.generateColumns() }
                    </Table>
                )}
            </AutoSizer>
        )
    }
} 




// WEBPACK FOOTER //
// ./src/features/common/VirtualizedTable/VirtualizedTable.js